'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mix = exports.single = undefined;

var _static = require('./static');

var _static2 = _interopRequireDefault(_static);

var _mixSetting = require('./mix-setting');

var _mixSetting2 = _interopRequireDefault(_mixSetting);

var _requiredString = require('./required-string');

var _requiredString2 = _interopRequireDefault(_requiredString);

var _isMobile = require('../utils/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var single = {
  appkey: _requiredString2.default,
  scene: _requiredString2.default,
  aeis: _static2.default,
  https: _static2.default,
  lang: {
    type: String,
    default: 'en'
  }
};

var mix = {
  appkey: _mixSetting2.default,
  scene: _mixSetting2.default,
  aeis: _static2.default,
  https: _static2.default,
  h5: {
    type: Boolean,
    default: _isMobile2.default
  },
  lang: {
    type: String,
    default: 'en'
  }
};

exports.single = single;
exports.mix = mix;
exports.default = {
  appkey: _mixSetting2.default,
  scene: _mixSetting2.default,
  aeis: _static2.default,
  https: _static2.default,
  lang: {
    type: String,
    default: 'en'
  }
};